import { render, staticRenderFns } from "./mobileGame.vue?vue&type=template&id=33bc9564&scoped=true"
import script from "./mobileGame.vue?vue&type=script&lang=js"
export * from "./mobileGame.vue?vue&type=script&lang=js"
import style0 from "./mobileGame.vue?vue&type=style&index=0&id=33bc9564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bc9564",
  null
  
)

export default component.exports